import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TSalesProcessingRequest,
	TSalesProcessingResponsePayload,
	TSalesProcessingStore,
	TProcessFileResponsePayload,
	TProcessFileRequest,
	TDownloadSalesReportResponsePayload,
	TDownloadSalesReportRequest,
	TProcessingTypesResponsePayload,
	TFileStatusesResponsePayload,
	TEmInvoicingFeeTypesResponsePayload,
} from './types';

const initialState: TSalesProcessingStore = {
	uploadedFiles: null,
	uploadedFilesLoading: false,
	processingTypes: null,
	processingTypesLoading: false,
	processFile: null,
	processFileLoading: false,
	processFileError: null,
	processFileSuccess: false,
	downloadFile: null,
	downloadFileLoading: false,
	fileStatuses: null,
	fileStatusesLoading: false,
	emInvoicingFeeTypes: null,
	emInvoicingFeeTypesLoading: false,
};

const salesProcessing = createSlice({
	name: '@@salesProcessing',
	initialState,
	reducers: {
		getUploadedFilesRequest: (
			state: TSalesProcessingStore,
			action: PayloadAction<TSalesProcessingRequest>,
		) => {
			const salesProcessingState = state;
			salesProcessingState.uploadedFilesLoading = true;
		},
		getUploadedFilesSuccess: (
			state: TSalesProcessingStore,
			action: PayloadAction<TSalesProcessingResponsePayload>,
		) => {
			console.log('getUploadedFilesSuccess action.payload', action.payload);
			const salesProcessingState = state;
			salesProcessingState.uploadedFiles = action.payload;
			salesProcessingState.uploadedFilesLoading = false;
		},
		getProcessingTypesRequest: (state: TSalesProcessingStore) => {
			const salesProcessingState = state;
			salesProcessingState.processingTypesLoading = true;
		},
		getProcessingTypesSuccess: (
			state: TSalesProcessingStore,
			action: PayloadAction<TProcessingTypesResponsePayload>,
		) => {
			const salesProcessingState = state;
			salesProcessingState.processingTypesLoading = false;
			salesProcessingState.processingTypes = action.payload;
		},
		processFileRequest: (
			state: TSalesProcessingStore,
			action: PayloadAction<TProcessFileRequest>,
		) => {
			const salesProcessingState = state;
			salesProcessingState.processFileLoading = true;
			salesProcessingState.processFileError = null;
			salesProcessingState.processFileSuccess = false;
		},
		processFileSuccess: (
			state: TSalesProcessingStore,
			action: PayloadAction<TProcessFileResponsePayload>,
		) => {
			const salesProcessingState = state;
			salesProcessingState.processFileLoading = false;
			salesProcessingState.processFileSuccess = true;
			salesProcessingState.processFileError = null;
		},
		processFileError: (state: TSalesProcessingStore, action: PayloadAction<string>) => {
			const salesProcessingState = state;
			salesProcessingState.processFileLoading = false;
			salesProcessingState.processFileError = action.payload;
			salesProcessingState.processFileSuccess = false;
		},
		downloadFileRequest: (
			state: TSalesProcessingStore,
			action: PayloadAction<TDownloadSalesReportRequest>,
		) => {
			const salesProcessingState = state;
			salesProcessingState.downloadFileLoading = true;
		},
		downloadFileSuccess: (state: TSalesProcessingStore) => {
			const salesProcessingState = state;
			salesProcessingState.downloadFileLoading = false;
		},
		getFileStatusesRequest: (state: TSalesProcessingStore) => {
			const salesProcessingState = state;
			salesProcessingState.fileStatusesLoading = true;
		},
		getFileStatusesSuccess: (
			state: TSalesProcessingStore,
			action: PayloadAction<TFileStatusesResponsePayload>,
		) => {
			const salesProcessingState = state;
			salesProcessingState.fileStatusesLoading = false;
			salesProcessingState.fileStatuses = action.payload;
		},
		getEmInvoicingFeeTypesRequest: (state: TSalesProcessingStore) => {
			const salesProcessingState = state;
			salesProcessingState.emInvoicingFeeTypesLoading = true;
		},
		getEmInvoicingFeeTypesSuccess: (
			state: TSalesProcessingStore,
			action: PayloadAction<TEmInvoicingFeeTypesResponsePayload>,
		) => {
			const salesProcessingState = state;
			salesProcessingState.emInvoicingFeeTypesLoading = false;
			salesProcessingState.emInvoicingFeeTypes = action.payload;
		},
	},
});

export default salesProcessing.reducer;

export const {
	getUploadedFilesRequest,
	getUploadedFilesSuccess,
	getProcessingTypesRequest,
	getProcessingTypesSuccess,
	processFileRequest,
	processFileSuccess,
	processFileError,
	downloadFileRequest,
	downloadFileSuccess,
	getFileStatusesRequest,
	getFileStatusesSuccess,
	getEmInvoicingFeeTypesRequest,
	getEmInvoicingFeeTypesSuccess,
} = salesProcessing.actions;
